import type {FullCourseOffering} from "@repo/sanity-utils/query-types";

const usd = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	maximumFractionDigits: 0,
});

/**
 * Format a numeric course price as whole-dollar USD.
 */
export function formatOfferingPrice(price: number): string {
	return usd.format(price);
}

/**
 * Resolve one offering's price using the selected campus override when the
 * modality displays campus-specific pricing.
 */
export function getOfferingPrice(
	offering: FullCourseOffering,
	displayMode: string | null | undefined,
	selectedCampusId: string | null,
	campusCoursePrices: Readonly<Record<string, number>>
): number | null {
	if (displayMode !== "campusLocation" || !selectedCampusId) {
		return offering.price;
	}

	// A missing or zero campus price falls back to the offering's base price.
	const campusPrice = campusCoursePrices[selectedCampusId] ?? 0;
	return campusPrice > 0 ? campusPrice : offering.price;
}
